import React, { createContext, useState, useEffect } from 'react';

// 챗봇 컨텍스트 생성
export const ChatbotContext = createContext();

// 로컬 스토리지 키
const STORAGE_KEY = 'chatbot_messages';

// 챗봇 컨텍스트 프로바이더 컴포넌트
export const ChatbotProvider = ({ children }) => {
  // 메시지 타입 상수
  const MESSAGE_TYPE = {
    USER: 'user',
    BOT: 'bot',
    SYSTEM: 'system'
  };

  // 초기 메시지
  const initialMessage = { 
    type: MESSAGE_TYPE.BOT, 
    content: '안녕하세요! 무엇을 도와드릴까요? 고객이나 상호작용에 관한 질문을 자유롭게 해주세요.', 
    timestamp: new Date() 
  };

  // 상태 관리
  const [messages, setMessages] = useState(() => {
    // 로컬 스토리지에서 메시지 불러오기
    const savedMessages = localStorage.getItem(STORAGE_KEY);
    
    if (savedMessages) {
      try {
        // JSON 파싱 및 타임스탬프 변환
        const parsed = JSON.parse(savedMessages);
        return parsed.map(msg => ({
          ...msg,
          timestamp: new Date(msg.timestamp)
        }));
      } catch (error) {
        console.error('저장된 메시지 파싱 오류:', error);
        return [initialMessage];
      }
    }
    
    return [initialMessage];
  });

  // 메시지 변경시 로컬 스토리지에 저장
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(messages));
  }, [messages]);

  // 메시지 추가 함수
  const addMessage = (message) => {
    setMessages(prev => [...prev, {
      ...message,
      timestamp: message.timestamp || new Date()
    }]);
  };

  // 메시지 초기화 함수
  const resetMessages = () => {
    setMessages([initialMessage]);
  };

  // 컨텍스트 값
  const value = {
    messages,
    addMessage,
    resetMessages,
    MESSAGE_TYPE
  };

  return (
    <ChatbotContext.Provider value={value}>
      {children}
    </ChatbotContext.Provider>
  );
}; 